import { ImpactCo2AnswerStatsPublic } from '@/domain/impact-stats/entities/stats-public.entity';

/**
 * This function preapre data to make sentence like :
 * - Concerne 11.1% des personnes pour 28 km en moyenne
 */
export function computeStatsForThisTransportationMode(
  publicMobilityItem: ImpactCo2AnswerStatsPublic['publicMobility'][number],
  sumTotalPassengerCount: number,
): {
  percentagePassenger: number;
  averageTravelDistance: number;
} {
  const percentagePassenger =
    publicMobilityItem.totalPassengerCount / sumTotalPassengerCount;

  const averageTravelDistance =
    publicMobilityItem.totalTravelDistance /
    publicMobilityItem.totalPassengerCount;

  return {
    percentagePassenger,
    averageTravelDistance,
  };
}

/**
 * This function preapre data to make sentence like :
 * - Concerne 66.8% des personnes pour 10 nuitées en moyenne
 */
export function computeStatsForThisAccommodationType(
  publicAccommodationItem: ImpactCo2AnswerStatsPublic['publicAccommodation'][number],
  sumTTotalGuestCount: number,
): {
  percentageGuest: number;
  averageNumberOfNights: number;
} {
  const percentageGuest =
    publicAccommodationItem.totalGuestCount / sumTTotalGuestCount;

  const averageNumberOfNights =
    publicAccommodationItem.totalNumberOfNights /
    publicAccommodationItem.totalGuestCount;

  return {
    percentageGuest,
    averageNumberOfNights,
  };
}
